module.exports = "/_next/static/images/ThankYou-c514abb72573c84db6b64e11fa90c191.svg";